import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PRODUCTVARIAN,
  DELETE_PRODUCTVARIAN,
  UPDATE_PRODUCTVARIAN,
  ADD_NEW_PRODUCTVARIAN,
} from "./actionType";

import {
  getProductVarianSuccess,
  getProductVarianFail,
  deleteProductVarianSuccess,
  deleteProductVarianFail,
  updateProductVarianSuccess,
  updateProductVarianFail,
  addProductVarianSuccess,
  addProductVarianFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getProductVarianApi,
  updateProductVarianApi,
  deleteProductVarianApi,
  addNewProductVarianApi
} from "../../helpers/backend_helper";

function* getProductVarian({ payload: productVarian }) {
  try {
    const response = yield call(getProductVarianApi, productVarian);
    yield put(getProductVarianSuccess(GET_PRODUCTVARIAN, response.data));
  } catch (error) {
    yield put(getProductVarianFail(GET_PRODUCTVARIAN, error));
  }
}

function* onUpdateProductVarian({ payload: productVarian }) {
  try {
    const response = yield call(updateProductVarianApi, productVarian);
    yield put(updateProductVarianSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateProductVarianFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteProductVarian({ payload: productVarian }) {
  try {
    const response = yield call(deleteProductVarianApi, productVarian);
    yield put(deleteProductVarianSuccess({ productVarian, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteProductVarianFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewProductVarian({ payload: productVarian }) {
  try {
    const response = yield call(addNewProductVarianApi, productVarian);
    yield put(addProductVarianSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addProductVarianFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetProductVarian() {
  yield takeEvery(GET_PRODUCTVARIAN, getProductVarian);
}

export function* watchUpdateProductVarian() {
  yield takeEvery(UPDATE_PRODUCTVARIAN, onUpdateProductVarian);
}

export function* watchDeleteProductVarian() {
  yield takeEvery(DELETE_PRODUCTVARIAN, onDeleteProductVarian);
}

export function* watchAddNewProductVarian() {
  yield takeEvery(ADD_NEW_PRODUCTVARIAN, onAddNewProductVarian);
}

function* productVarianSaga() {
  yield all([
    fork(watchGetProductVarian),
    fork(watchDeleteProductVarian),
    fork(watchUpdateProductVarian),
    fork(watchAddNewProductVarian)
  ]);
}

export default productVarianSaga;
